// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"ac7bfd45","372":"111f4440","453":"42f2fa2a","547":"f3fed3ab","570":"574439b3","788":"b370a865","882":"a59e7b4c","966":"703a3a44","991":"cbc76d99"}[chunkId] + ".chunk.js";
};